<span
  class="status-badge px-3 py-2 fw-bold rounded-pill"
  [style.color]="color"
  [style.backgroundColor]="backgroundColor"
>
  {{ value }}
</span>
